//Generated File 
export default class GUIDevMode{
	static readonly APP_URL = ``;
	static readonly GUI_BASE_PATH = ``;
}
